import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-delete',
    templateUrl: './delete.component.html',
    styleUrls: ['./delete.component.css'],
    standalone: false
})
export class DeleteComponent {
  @Input() info: any;
  constructor(public activeModal: NgbActiveModal) {}
  Delete() {
    if (this.info.id) {
      this.activeModal.close(this.info.id);
    }
  }
}
